import level1 from "./level1";

export default {
  level1: level1,
  bidDialog: {
    notPassAudit: "The project didn’t pass the audit you can now apply to get your {fundsPaid} USDC investment refunded",
    canNowWithdraw: "You can now withdraw your investment of {fundsPaid} USDC",
    seeTransaction: "See transaction",
    biddingEnded: "Unfortunately, the bidding period has ended, your registration offer has not been processed.",
    youHave: "You have",
    allocations: "allocations",
    title: "Bid carbon credits from {projectName}",
    whitelisted: "You are whitelisted for buying carbon credits from project {projectName} for a price of ${listingPrice}.",
    network: "Network",
    smartContract: "Smart contract",
    price: "Price",
    youReceive: "You receive",
    remainingAllocation: "Remaining allocation",
    youPay: "You pay",
    balance: "Balance",
    gasEstimated: "Gas (estimated)",
    bid: "Bid",
    setSpendingCap: "Set Spending Cap",
    bidTransaction: "Bid Transaction",
    status: "Status",
    notWhitelisted: "You are not whitelisted for this carbon credit offering or you have already finished your allocation. Please contact Brazil Carbon team for participating in future carbon credit offerings.",
    switchNetwork: "You need to switch to {requiredNetworkName} for being able to buy carbon credits. This project is on network ID {projectId}, while you're currently on network ID {networkId}.",
    investmentTitle: "You successfully invested",
    investmentText: "You received { showAmount } { symbol }",
    investmentText2: "You have successfully purchased { showAmount } carbon credits from { name }.",
    investmentText3: "You can also view the transaction details on the blockchain explorer.",
    investmentText4: "You have successfully purchased { showAmount } agroforestry tokens from { name }.",
    wallet: "wallet",
    page: "page",
    max: "MAX",
    unknownNetwork: "Unknown Network",
    backToBid: "Back to bid",
    error: "Error",
    biddingClosed: "Bidding closed",
    biddingClosedText: "Unfortunately, the bidding period has ended, your registration offer has not been processed.",
    hours: "h",
    minutes: "min",
    left: "left",
    currentBid: "Current Bid",
    for: "for",
    insufficientFund: "Insufficient fund",
    placeBid: "Place bid",
    fullyBidAllocations: "You fully bid your allocations",
    carbonCredit: "Carbon Credit",
    AgroforestryProducts: "Agroforestry Product"
  },
  connectButton: {
    account: "Account",
    manageAccount: "Manage Account",
    connectWallet: "Connect Wallet",
    signedInAs: "Signed in as",
    acmeGmbH: "Acme GmbH",
    copyAddressTooltip: "Copy Address",
    viewOnExplorerTooltip: "View on Explorer",
    myWallet: "My Wallet",
    disconnect: "Disconnect",
    totalCredit: "Total credits",
    projectFunded: "project funded",
    openWallet: "Open wallet",
    login: "Connect wallet",
    loginToInvest: "Log in to invest",
    currentYear: "Current Year"
  },
  connectDialog: {
    loginWithEmail: "Log in with Email",
    continueWithWallet: "or continue with a wallet",
    login: "Login",
    email: "Email",
    password: "Password",
    login_farmer: "Log in as a farmer",
    title: "Connect wallet",
    description: "Learn more about wallets",
    signIn: "Sign in",
    connectingWallet: "Connecting to your wallet",
    clickConnect: "Click connect in your wallet popup",
    selectAccount: "Select the account to use on this site.",
    ledgerSteps: {
      step1: "Connect the ledger device to your computer.",
      step2: "Enter your PIN and access your device.",
      step3: "Ensure you have installed the Avalanche App and open it on your device.",
      step4: "Verify your wallet address on the device.",
      step5: "Sign the message shown on your Ledger to complete the sign-in process."
    },
    retry: "Retry",
    noWallets: "No wallets?",
    welcome: "Welcome to Brazil Carbon",
    login_investor: "Log in as an investor",
    login_developer: "Log in as a developer",
    continue_farmer: "Continue as a farmer",
    continue_investor: "Continue as an investor",
    continue_developer: "Continue as a developer",
    back: "Back",
    cancel: "Cancel",
    walletConnectTimeout: "Wallet connection timed out. Please try again.",
    walletConnectionFailed: "We could not connect your wallet. Please try again.",
    invalid_cred: "Invalid credentials",
    loginOrSignUp: "Log in or sign up"
  },
  footerComp: {
    committed: "Committed to the",
    copyright: {
      line1: "©2023 Brazil Carbon Technology Company",
      line2: "All Rights Reserved. This product is protected by copyright and distributed under licenses restricting copying, distribution, and decompilation."
    },
    navigation: {
      helpPage: "Help",
      contact: "Contact"
    },
    tagline: "Invest in real-world bioeconomy projects in Brazil",
    copyrightNew: "© Brazil Carbon 2026",
    invest: {
      title: "Invest",
      carbonCredits: "Carbon Credits",
      agroforestry: "Agroforestry"
    },
    participate: {
      title: "Participate",
      listProject: "List a project",
      partnerWithUs: "Partner with us"
    },
    getInTouch: {
      title: "Get in touch",
      linkedin: "LinkedIn",
      contactUs: "Contact us"
    },
    privacyPolicy: "Privacy Policy"
  },
  registerCard: {
    registerApproved: "Registration Approved",
    approved: "Approved",
    rejected: "Rejected",
    awaitingApproval: "Awaiting approval"
  },
  investCard: {
    state: "State",
    creditType: "Credit Type",
    creditTypeOptions: {
      reforestation: "Reforestation",
      soilSequestration: "Soil Sequestration",
      energyEfficiency: "Energy Efficiency",
      carbonMethaneCapture: "Carbon Methane Capture",
      renewableEnergyDevelopment: "Renewable Energy Development",
      highPotencyGHGCapture: "High Potency GHG Capture",
      avoidDeforestation: "Avoided Deforestation",
      community: "Community",
      wasteToEnergy: "Waste to Energy"
    },
    tokenSymbol: "Token symbol",
    balance: "Balance",
    projectDetailsButton: "Project details"
  },
  ownerCard: {
    manageWallet: "Manage Wallet",
    offeringState: {
      tba: "TBA",
      paused: "Paused",
      live: "Live",
      finalized: "Finalized",
      inactive: "Inactive",
      unsuccessful: "Unsuccessful",
      noOffering: "No offering",
      registered: "Registered",
      registerClosed: "Registration closed",
      pendingOffering: "Pending offering",
      successful: "Successful",
      awaitingApprove: "Awaiting approval"
    },
    auditUnsuccess: "Audit unsuccessful",
    awaitingApprove: "Awaiting approval",
    allocation: "Credits registered",
    fundsRaised: "Funds Raised",
    total: "Total",
    network: "Network",
    contract: "Contract",
    status: "Status",
    statusValues: {
      inactive: "Inactive",
      offeringPeriod: "Offering period",
      lockedUntil: "Locked until",
      unlocked: "Unlocked",
      withdrawn: "Withdrawn",
      unsuccessful: "Unsuccessful"
    },
    state: "State",
    tokenSymbol: "Token symbol",
    projectDetailsButton: "Project details",
    auditTimeline: "Carbon Credit Audit Timeline",
    audit: "Audit",
    copyAddress: "Copy Address",
    viewOnExplorer: "View on Explorer",
    auditPeriod: "Audit period"
  },
  navBar: {
    about: "About",
    projects: "Projects",
    token: "Token",
    jurisdictionCredit: "Jurisdiction credit",
    dashboard: "Dashboard",
    beta: "beta",
    investInProjects: "Invest in Projects",
    buyCarbonCredits: "Buy Carbon Credits",
    myDashboard: "My dashboard"
  },
  registerDialog: {
    tonsUpper: "Tons",
    agroforestry: "Agroforestry",
    discoverOtherProjects: "Discover other projects",
    connectedWallet: "connected wallet",
    walletAddress: "Wallet Address",
    registration: "Registration",
    businessName: "Business Name",
    required: "This field is required",
    businessNameMaxLength: "Business name must be at most 255 characters",
    fullName: "Full Name",
    fullNameMaxLength: "Full name must be at most 255 characters",
    businessIncorporationDate: "Business Incorporation Date",
    dateInvalid: "Please enter a valid date in DD-MM-YYYY format",
    yearMustBeCurrentOrEarlier: "The date must be today or earlier.",
    email: "Email",
    emailInvalid: "Please enter a valid email address",
    oneCreditEquals: "1 credit = {price} USDC",
    maxSupply: "Max supply: {maxSupply}",
    maxSupplyTitle: "Carbon Credits Fully Allocated",
    maxSupplyText: "All carbon credits for this project have been allocated; explore other projects for available opportunities.",
    amountGreater: "Amount must be greater than 0.",
    amountMaxSupply: "Amount must be less than or equal to available supply.",
    walletAddressInvalid: "Please enter a valid wallet address",
    pasteWallet: "Paste connected wallet address",
    connectWallet: "Connect your wallet to paste your address",
    verification: "Verification",
    amlCheck: "AML Check",
    performingAmlCheck: "Performing AML Check...",
    amlCheckPassed: "AML Check Passed Successfully!",
    back: "< Back",
    continue: "Continue",
    register: "Register",
    toBeAnnounced: "Price To be announced",
    registerClosed: "Registration closed",
    onlyRegisteredBid: "Only registered buyers can bid",
    offerFinalized: "Offering finalized",
    youAreRegisteredTitle: "You are registered!",
    youRequested: "you requested",
    credits: "credits",
    changeAllocation: "Change allocation",
    unableApprove: "Unable to Approve",
    unableApproveText: "After careful consideration, we regret to inform you that we are unable to approve your application at this time",
    registerEnded: "Registration ended",
    sendEmail: "We will send you an Email as soon as the sale starts",
    registerSale: "Register for sale",
    information: "Information",
    amount: "Amount",
    available: "available",
    carbonCredit: "Carbon Credit",
    AgroforestryProducts: "Agroforestry Product",
    creditsCapital: "Credits",
    carbonCredits: "Carbon Credits",
    agroProducts: "Agroforestry products",
    verifying: "Verifying",
    verifyingText: "Can take up to a minute. we will get back to you soon!",
    verifyingButton: "Registration submitted",
    insufficientFund: "Insufficient fund",
    submit: "Submit",
    logo: "Company Logo",
    webPage: "Website URL",
    companyRegistryNumber: "Company Registry Number",
    dateOfIncorporation: "Date of Incorporation",
    phone: "Phone Number",
    invalidUrl: "Enter a valid URL (e.g., https://example.com)",
    companyRegistryMaxLength: "Company registry number must be at most 50 characters",
    invalidPhone: "Enter a valid phone number"
  },
  networkButton: {
    networkIconAlt: "Network Icon",
    mainnetsTab: "Mainnets",
    testnetsTab: "Testnets",
    switchNetwork: "Switch Network"
  },
  withdrawComp: {
    unlockedFunds: "Unlocked funds",
    nextUnlock: "Next unlock",
    withdraw: "Withdraw",
    withdrawWithAmount: "Withdraw ${remainingFundsUnlocked}",
    usdcCommission: "USDC Commission",
    creditCommission: "Credits Commission"
  },
  contactPage: {
    contactUs: "Contact us"
  },
  projectsPage: {
    title: "Explore quality projects",
    allProjectsTitle: "All Projects",
    registerClosed: "Registration closed",
    registered: "Registered",
    noCreditsAvailable: "There are no more credits available!",
    totalCredits: "credits in total",
    pricePerTon: "/metric ton of CO₂e",
    bid: "Bid",
    register: "Register",
    offeringFinalized: "Offering finalized",
    offeringCreated: "Offering created.",
    participantsWhitelisted: "Participants whitelisted.",
    upcomingOffering: "Upcoming offering",
    allocated: "Allocated",
    total: "Total Credits",
    startRefund: "Start Refund",
    withdraw: "Withdraw",
    withdrawn: "Withdrawn",
    paused: "Paused",
    landHectaresTitle: "1.2k",
    landHectaresText: "Hectares",
    carbonCreditsTitle: "12M",
    carbonCreditsText: "Credits",
    lockedValueTitle: "$2.3M",
    lockedValueText: "Value offered",
    registry: "Registry",
    carbonTitle: "Invest in High Integrity Carbon Credits",
    agroTitle: "Invest in anti-fragile food systems",
    tabs: {
      carbon: "Carbon Credits",
      agroforestry: "Agroforestry"
    }
  },
  projectDetail: {
    changeLocation: "Change location",
    projectDesignDocument: "Project Design Document",
    projectFeasibilityReport: "Project Feasibility Report",
    developer: "Developer",
    certifiedBy: "Certified by",
    type: "Type:",
    state: "State:",
    bid: "Bid",
    offeringFinalized: "Offering finalized",
    offeringCreated: "Offering created.",
    participantsWhitelisted: "Participants whitelisted",
    upcomingOffering: "Upcoming offering",
    overview: "Overview",
    biodiversity: "Biodiversity",
    flora: "Flora",
    fauna: "Fauna",
    endangeredAnimals: "Endangered animals",
    species: "species",
    files: "Documents",
    photos: "Photos",
    download: "Download",
    offeringPaused: "Offering paused",
    paused: "Paused",
    seeAllPhotos: "See all photos",
    fileName: "File",
    location: "Location",
    category: "Category",
    completed: "Funding completed",
    auditUnsuccesful: "Audit unsuccessful",
    cantParticipate: "Sorry. you can’t participate in that project",
    applyToGetRefund: "Apply for refund",
    requestAccepted: "Request accepted",
    canWithdraw: "You can now withdraw your USDC",
    alreadyWithdwan: "Amount withdrawn",
    withdrawnText: "You withdrew {usdcAmount} USDC",
    registerForSale: "Register for sale",
    totalAreaHectares: "{project_area_hectares} hectares",
    fundingCollected: "Funding Collected",
    fundingTarget: "Funding Target",
    partner: "Partner"
  },
  wallet: {
    owned: "Owned projects",
    invested: "Invested projects",
    registered: "Registered projects"
  },
  confirmDialog: {
    deleteProjectTitle: "Delete Project",
    deleteProjectContent: "Are you sure you want to delete this project?",
    deleteDraftTitle: "Delete draft",
    deleteDraftContent: 'Are you sure you want to delete "{name}"?',
    confirm: "Confirm",
    cancel: "Cancel",
    deleteWarning: "This action cannot be undone."
  },
  labels: {
    successful: "Successful",
    unsuccessful: "Unsuccessful",
    startAudit: "Start Audit",
    windowNotOpen: "Audit Window Not Open",
    auditSuccess: "Audit Success",
    cancelUnsuccessful: "Cancel Unsuccessful Audit",
    days: "days",
    day: "day",
    auditorProjects: "Auditor Projects",
    developerProjects: "Developer Projects",
    developerDrafts: "Draft carbon projects",
    developerCarbonDrafts: "Carbon financing drafts",
    developerListedCreditDrafts: "Listed credit drafts",
    noDeveloperDrafts: "You don't have any saved drafts yet.",
    resumeDraft: "Continue draft",
    draftStep: "Step {step}",
    draftStatus: "Status: {status}",
    lastSaved: "Last saved {date}",
    addProject: "Create a new project",
    audits: "Audits",
    partnerProjects: "Partner Projects"
  },
  developerPage: {
    hectares: "Hectares",
    projectType: "Project Type",
    step1Title: "Project Details",
    step2Title: "Project Files",
    resultTitle: "Results",
    addProjectFiles: "Add Project Files",
    uploadProjectPhotos: "Upload Project Photos (Max 16 JPG, JPEG or PNG)",
    uploadForestPhoto: "Upload Forest Cover Photo (Max 1 JPG, JPEG or PNG)",
    uploadProjectFiles: "Upload Project Files (Max 4 PDF)",
    photosUploading: "Uploading Photos...",
    filesUploading: "Uploading Files...",
    upload: "Upload",
    progress: "Progress",
    results: "Results",
    projectData: "Project Data",
    noPhotos: "No",
    images: "images",
    projectPhotos: "Project Photos",
    projectFiles: "Project Files",
    noFiles: "No",
    pdfs: "PDF's",
    noFileUploaded: "No file uploaded",
    back: "Back",
    continue: "Continue",
    backToProjectsList: "Back to Projects List",
    finished: "Finished!",
    nameForText: "Project Name",
    auditor: "Project Auditor",
    state: "Select Brazil State",
    carbonCreditSupply: "Carbon Credit Supply",
    listingPrice: "Listing Price",
    overview: "Overview",
    biodiversity: "Biodiversity",
    floraCount: "Flora species count",
    faunaCount: "Fauna species count",
    endangeredSpeciesCount: "Endangered species count",
    userNotAuthenticated: "User is not authenticated",
    summary: "Project Summary",
    commission: "Developer USD Commission",
    creditCommission: "Developer Carbon Credit Commission",
    calcReddCost: "Calculate REDD+ cost",
    auditorVerification: "Auditor for Verification",
    auditorValidation: "Auditor for Validation",
    projectDeveloper: "Project Developer",
    projectCertifier: "Project Certifier",
    selectBrazilState: "Select Brazil State",
    inflationRate: "Inflation Rate",
    projectCoBenefitors: "Project Co-Benefitors",
    landOwner: "Land Owner",
    forestCover: "Forest Cover",
    yearsPeriod: "Project Duration in Years",
    investorsPercent: "Investors (%)",
    ownersPercent: "Owners (%)",
    developersPercent: "Developer (%)",
    platformPercent: "Platform (%)",
    stakersPercent: "Stakers (%)",
    historicalDeforestationRate: "Historical Deforestation Rate (0-1 scale)",
    carbonSequestrationRate: "Carbon Sequestration Rate (tons/year)",
    deforestationDrivers: "Deforestation Drivers",
    deforestationAgents: "Deforestation Agents",
    ecosystemServicesValuation: "Ecosystem Services Valuation",
    biomeAreaHectares: "Biome Area (hectares)",
    auditorFee: "Auditor Fee (%)",
    auditCost: "Audit Cost",
    tokenName: "Token Name",
    tokenSymbol: "Token Symbol",
    registerAsDeveloper: "Register as developer",
    numberCarbonCredits: "Number of Carbon Credits"
  },
  validation: {
    fieldRequired: "This field is required",
    required: "{field} is required."
  },
  projectStates: {
    projectDesign: "Project Design",
    validation: "Validation",
    registration: "Registration",
    monitoring: "Monitoring",
    verification: "Verification",
    certifiedEmissionReduction: "Issuance",
    offering: "Offering",
    liveOffering: "Live Offering",
    finalizedOffering: "Finalized Offering",
    audit1: "Audit 1",
    audit2: "Audit 2",
    audit3: "Audit 3",
    audit4: "Audit 4",
    audit5: "Audit 5",
    audit: "Audit",
    projectCycle: "Lifecycle",
    credits: "credits",
    feasibilityAssessment: "Feasibility assessment"
  },
  errors: {
    errorEnterName: "Please fill the name field.",
    errorOccrred: "Unexpected error occurred, please try again later.",
    insuffFunds: "Insufficient funds for gas.",
    fillRequiredFields: "Please fill in all the required fields",
    validDate: "Please enter a valid date in DD-MM-YYYY format",
    currentOrEarlierDate: "The date must be current or earlier",
    validEmail: "Please enter a valid email address",
    invalidWalletAddress: "Invalid Ethereum address. Please check and try again",
    amountGreaterThanZero: "Amount must be greater than 0",
    failedToRegister: "Failed to register. Please try again.",
    blacklistedWallet: "Wallet address is blacklisted. Contact support.",
    cannotGetContractAddress: "Cannot get contract address.",
    withdrawalFailed: "Withdrawal failed. Please try again.",
    metamaskNotDetected: "MetaMask extension is not detected. Please install MetaMask to continue.",
    metamaskLockedOrOtherWalletActive: "MetaMask is locked or another wallet extension is active. Please unlock MetaMask and disable other wallet extensions.",
    metamaskRequestPending: "MetaMask already has a pending permission request. Please open MetaMask and finish or cancel the previous request.",
    connectingMetamask: "Error connecting to MetaMask: {message}",
    connectingLedger: "Error connecting to Ledger: {message}",
    failedToGetLedgerPublicKey: "Failed to get public key from Ledger device.",
    auditNotConfirmed: "Audit was not confirmed successful by the auditor.",
    transactionCanceled: "You have canceled the transaction.",
    tokenBurningFailed: "Error on burning tokens",
    tokenWithdrawalFailed: "Error on withdrawing tokens",
    walletBlacklisted: "Wallet address is blacklisted. Contact support.",
    uploadPhotosAndDocuments: "Please upload both photos and documents before proceeding.",
    selectLocationOnMap: "Please select a location on the map.",
    submitFormFailed: "Error while submitting form.",
    auditorCoverageMissing:
      "No auditor is configured for agroforestry projects in this region. Please ask an admin to add auditor coverage before submitting.",
    projectIdFailed: "Failed to obtain project ID. Project creation might have failed.",
    uploadFilesOrPhotosFailed: "Error while uploading files or photos.",
    selectAtLeastOnePhoto: "You should select at least 1 photo.",
    noCachedPhotos: "No cached photos found.",
    photoUploadFailed: "Photo upload not successful: {response}",
    selectAtLeastOneFile: "You should select at least 1 file.",
    filesUploadFailed: "Files upload not successful: {response}",
    projectUpdateFailed: "Failed to update the project.",
    projectCreateFailed: "Failed to create the project.",
    selectProjectAuditor: "Please select the project auditor.",
    updateProjectFailed: "Error while updating the project.",
    obtainProjectIdFailed: "Failed to obtain project ID. Project creation might have failed.",
    noCachedFiles: "No cached files found.",
    fileUploadFailed: "File upload not successful: {reason}",
    createProjectFailed: "Failed to create the project.",
    walletAddressAlreadyRegistered: "The wallet address was already registered in this project",
    auditStartFailed: "Audit start failed!",
    auditConfirmFailed: "Audit confirmation failed!",
    auditPauseFailed: "Audit pause failed!",
    auditCancelFailed: "Cannot cancel unsuccessful audit",
    auditCancelFailedTokens: "Cannot cancel unsuccessful audit. Tokens already burned",
    cantChangeAllocations: "Error on changing allocations. Please try again later",
    enterProjectName: "Please enter the project name.",
    selectProjectType: "Please select the project type.",
    selectState: "Please select a state.",
    enterAuditorValidation: "Please select an auditor for validation.",
    enterAuditorVerification: "Please select an auditor for verification.",
    enterForestCoverInfo: "Please enter forest cover information.",
    selectProjectDuration: "Please select the duration of the project in years.",
    enterHistoricalDeforestationRate: "Please enter the historical deforestation rate.",
    enterCarbonSequestrationRate: "Please enter the carbon sequestration rate.",
    enterDeforestationDrivers: "Please describe the deforestation drivers.",
    enterDeforestationAgents: "Please list the deforestation agents.",
    enterEcosystemServicesValuation: "Please provide an ecosystem services valuation.",
    enterBiomeArea: "Please enter the biome area in hectares.",
    enterProjectArea: "Please enter the project area in hectares.",
    selectLandTenureStatus: "Please select the land tenure status.",
    selectBiome: "Please select the biome.",
    enterProjectGoal: "Please enter an overview of the project.",
    enterProjectSummary: "Please provide information about the project's biodiversity.",
    enterTokenSupply: "Please enter the total token supply.",
    enterListingPrice: "Please enter the token listing price.",
    enterTokenName: "Please enter a name for the token.",
    enterTokenSymbol: "Please enter a token symbol (e.g., ECO).",
    allocationIsNone: "Allocation is none",
    allocationSumTooHigh: "Sum of allocations can't be greater than 100",
    allocationSumTooLow: "Sum of allocations lower than 100",
    addOwnersOrZero: "Add owners to cover allocations or set owner allocations to 0",
    invalidOwnerAllocation: "Please write correct numbers in allocation fields",
    ownerAllocationTooHigh: "Owner allocations can't be greater than {percent}",
    ownerAllocationTooLow: "Owner allocations lower than {percent}",
    mintingFailed: "Error while minting project.",
    projectCreationFailed: "Error on project creation",
    activityNameRequired: "Activity name is required.",
    activityIconRequired: "Please select an icon for each activity.",
    activityDescriptionRequired: "Description is required.",
    oneSentenceDescription: "Please write only one sentence ending with a period, exclamation mark, or question mark.",
    enterAtLeastOneActivity: "Please enter at least one activity before continuing.",
    selectCertificationNumber: "Please enter the certification number.",
    selectCertificationBody: "Please enter the certification body.",
    selectCertificationReport: "Please enter the certification report URL.",
    selectIssuanceDate: "Please enter the issuance date.",
    selectCertifier: "Please select the certifier."
  },
  success: {
    allocationChanged: "Allocations was changed",
    registrationReceived: "Your registration request has been successfully received, thank you!",
    registeredSuccessfully: "You have registered successfully",
    withdrawalSuccessful: "Withdrawal successful! Your balance has been updated.",
    registeredSuccessfullyMore: "All allocations for this offering have been filled. However, if other users currently under review are not accepted, you may be allocated up to the amount you requested.",
    tokensBurned: "Tokens burned successfully",
    tokensWithdrawn: "Tokens withdrawn successfully",
    photosCached: "Photos cached successfully.",
    photosUploaded: "Photos were uploaded successfully.",
    filesCached: "Files cached successfully.",
    filesUploaded: "Project files were uploaded successfully.",
    projectUpdated: "Project updated.",
    projectCreated: "Project created in database.",
    auditStarted: "Audit started successfully!",
    auditConfirmed: "Audit confirmed successfully!",
    auditPaused: "Audit paused successfully!",
    auditCanceled: "Audit canceled successfully!"
  },
  scrollTop: {
    scrlTop: "Scroll to top"
  },
  indexPage: {
    parallax: {
      title1: "High Integrity",
      title2: "Carbon Credits from Brazil",
      description: "Transparent, Trusted, and Built for Climate Action"
    },
    ourDevelopers: "Our Developers",
    scalingTitle: "Transforming the Carbon Credit Market in Brazil",
    scalingDescription: "By connecting companies with certified local projects to easily offset emissions and create real change. With full transparency and seamless access, everyone benefits—this is emission reduction done right!",
    scalingItem1Title: "50 M",
    scalingItem1Description: "Hectares protected from deforestation",
    scalingItem2Title: "%15",
    scalingItem2Description: "Of Brazil’s potential carbon sequestration",
    scalingItem3Title: "$300B",
    scalingItem3Description: "Market potential by 2050",
    scalingItem4Title: "8.5 M",
    scalingItem4Description: "Employment opportunities",
    scalingItem5Title: "15x",
    scalingItem5Description: "Projected growth over 10 years",
    howWorks: {
      title: "How it works",
      step: "Step",
      itemTitle1: "Carbon credit calculation",
      itemDescription1: "Working with remote sensing and soil analysis data",
      itemTitle2: "Tokenized carbon credits",
      itemDescription2: "To digitize carbon credits, they are tokenized on the blockchain",
      itemTitle3: "Smart contract auctions",
      itemDescription3: "Tokens are auctioned via smart contracts to ensure secure bidding",
      itemTitle4: "Periodic audits for transparency",
      itemDescription4: "Funds are released after successful audits for continuous accountability",
      descriptionTitle1: "Investment",
      descriptionTitle2: "Protection",
      descriptionText1: "We guarantee your investment is fully protected. If an audit fails, you can return the carbon credit for a refund or claim compensation directly from our carbon credit reserve pool—your security is assured every step of the way.",
      descriptionText2: "claim compensation directly from our carbon credit reserve pool—your security is assured every step of the way.",
      descriptionText: "If an audit fails, you can return the carbon credit for a refund or claim compensation directly from our carbon credit reserve pool—your security is assured every step of the way.",
      descriptionTitle: "We guarantee your investment is fully protected."
    },
    featuredProjects: {
      title: "Featured projects",
      seeAll: "See all",
      description: "Interested in featuring your project?",
      link: "Reach out to become a partner today"
    },
    testimonials: {
      title: "Testimonials",
      role1: "Project owner",
      role2: "Developer",
      role3: "Designer"
    },
    auditsBy: {
      title: "Audited by"
    },
    forYou: {
      title: "Built for farmers and developers",
      tabs: {
        farmers: "For Farmers",
        developers: "For Developers"
      },
      farmers: {
        card1: "Satellite-verified land registration",
        card2: "Funding without the paperwork",
        card3: "Direct payments straight to your wallet",
        card4: "Money to expand and improve your farm",
        card5: "Just deposit — we handle every payment",
        card6: "Returns that grow with your actual harvest",
        feature1: "Satellite-verified land registration",
        feature2: "Funding without the paperwork",
        feature3: "Direct payments straight to your wallet",
        feature4: "Money to expand and improve your farm",
        feature5: "Just deposit — we handle every payment",
        feature6: "Returns that grow with your actual harvest"
      },
      developers: {
        card1: "Launch new projects in minutes, not months",
        card2: "Smart pricing built in for every stage",
        card3: "Project documentation generated automatically",
        card4: "Built-in marketplace to reach verified investors",
        card5: "Satellite monitoring and verification, ready to use",
        card6: "End-to-end budgeting and financing tools",
        feature1: "Launch new projects in minutes, not months",
        feature2: "Smart pricing built in for every stage",
        feature3: "Project documentation generated automatically",
        feature4: "Built-in marketplace to reach verified investors",
        feature5: "Satellite monitoring and verification, ready to use",
        feature6: "End-to-end budgeting and financing tools"
      }
    },
    faq: {
      title: "FAQ",
      questionTitle1: "How can I buy a carbon credit on the platform?",
      questionDescription1: "You need to register for a carbon credit offering within one of the projects. Once the offering starts, you will receive an email notification, informing you that you can proceed with purchasing carbon credits.",
      questionTitle2: "How do I register for a carbon credit offering?",
      questionDescription2: "To register, follow these steps:\n• Navigate to the Projects page, where you will find a list of available carbon credit projects.\n• Click on the \"Register\" button next to the project you'd like to participate in.\n• Fill out the required information: your business name, business date, full name, wallet address, and the amount of allocations you are interested in purchasing.\n• Once you submit your registration, you will receive an email confirming that your application is under review. Our team will verify the legitimacy of your details before approving your application.",
      questionTitle3: "What are the requirements to participate in carbon credit offerings?",
      questionDescription3: "To participate in carbon credit offerings, you need to:\n• Register on the platform by providing your business details, wallet address, and the amount of credits you wish to purchase.\n• Have an approved account after our team verifies your registration.\n• Ensure you have the required amount of USDC in your connected wallet, as all payments are processed through smart contracts using USDC.\n• You cannot bid for more than the amount you have been allocated during the registration process.",
      questionTitle4: "Where can I view the carbon credits I've purchased?",
      questionDescription4: "After you have successfully bid on carbon credits and the transaction is confirmed, you will receive the credits in your wallet. You can view these credits:\nIn your connected wallet, such as MetaMask or any of the other supported wallets, after importing the token contract address. We strongly advise using a Ledger wallet for high-volume transactions for enhanced security.\nOn the Dashboard page, your allocations and remaining credits will be visible under your account.",
      questionTitle5: "Can I make bank transfers during payment?",
      questionDescription5: "No, the platform only supports payments via USDC tokens through a connected wallet. Bank transfers or fiat currency transactions are not supported at this time.",
      questionTitle6: "How do I see if a project is unsuccessful?",
      questionDescription6: "You will receive notifications via email if the project you participated in encounters any issues. Additionally, the project's status will be updated on your Dashboard.",
      questionTitle7: "If a project fails after some years, how can I get a refund?",
      questionDescription7: "If a project fails during one of the audits, you can initiate a refund by returning your carbon credits to the smart contract:\nYou will be able to send the purchased carbon credits back to the contract. To do so, navigate to the project details page with your connected wallet. If an audit was unsuccessful, you will see the \"Apply to get refunded” button. Click this button and confirm the transaction in your wallet.\nOnce the credits are received, you will see the \"Withdraw\" button. Click this button and confirm the transaction in your wallet. The smart contract will automatically burn the tokens, and you will receive a refund in USDC, proportionate to the time remaining after the audit failure, minus any applicable commissions.\nYou will also be notified of the refund process via email, with instructions on how to complete the transaction.",
      questionTitle8: "Is the tokenization of carbon credits legally recognized?",
      questionDescription8: "While tokenization is not yet specifically regulated in Brazil, the sale of carbon credits remains recognized within the voluntary carbon market. Tokenization is a technological innovation that aims to facilitate the trading of these credits, and its legal acceptance depends on compliance with environmental norms and transparency to ensure the validity of tokenized assets.",
      questionTitle9: "Does the company offer legal guarantees on the validity of tokenized carbon credits?",
      questionDescription9: "Yes, the company ensures that the tokenized carbon credits have been verified and validated by recognized standards.",
      questionTitle10: "How is the authenticity and validity of tokenized carbon credits ensured?",
      questionDescription10: "The authenticity and validity of tokenized carbon credits are ensured through verification and certification by independent entities and internationally recognized standards. Additionally, blockchain technology guarantees the traceability and immutability of transactions, providing greater legal security for the parties involved.",
      questionTitle11: "Is the tokenization of carbon credits legally recognized in Brazil?",
      questionDescription11: "The tokenization of carbon credits in Brazil is not yet directly regulated, but within the voluntary market, its use is allowed. Tokenization facilitates the trading and tracking of these assets through blockchain technology, following internationally recognized standards."
    },
    ourPartners: "Our Partners",
    hero: {
      title: "Invest in real-world bioeconomy projects in Brazil",
      subtitle: "Stage-based investing with verified milestones and built-in capital protection. Local, data-driven, and transparent by design.",
      exploreProjects: "Explore projects",
      listProject: "List a project"
    },
    listProjectDialog: {
      title: "List a project",
      subtitle: "Continue as",
      connectDeveloper: "Connect as Developer",
      connectFarmer: "Connect as Farmer",
      roleMismatch: "Please connect with the selected role before listing a project."
    },
    productCards: {
      activeProjectsCount: "{count} active projects",
      loadingProjects: "Loading projects",
      projectCountUnavailable: "Projects unavailable",
      carbonCredits: {
        title: "Carbon Credits",
        description: "Locally issued, verified Brazilian carbon credits, tokenized at issuance for transparent, efficient trading or retirement.",
        activeProjects: "12 active projects"
      },
      agroforestry: {
        title: "Agroforestry",
        description: "Climate-resilient farming systems combining multiple crops on the same land, delivering stable long-term yields and USDC cash-flow returns.",
        activeProjects: "12 active projects"
      }
    },
    whyInvest: {
      title: "Why invest with Brazil Carbon?",
      tabs: {
        agroforestry: "Agroforestry",
        carbonCredits: "Carbon Credits"
      },
      agroforestry: {
        feature1: "Climate-resilient and drought-resistant farming systems",
        feature2: "Multiple crops from the same land (cacao, açaí, coffee, cupuaçu)",
        feature3: "Cash-flow returns paid in USDC",
        feature4: "Lower long-term costs due to healthier soils",
        feature5: "More long term stability and profitability than monoculture farming",
        feature6: "Supports biodiversity while generating income"
      },
      carbonCredits: {
        feature1: "Verified carbon credits from certified Brazilian projects",
        feature2: "Tokenized on-chain for transparent, efficient trading",
        feature3: "Stage-based capital release with milestone verification",
        feature4: "Built-in investor protection through smart contracts",
        feature5: "Periodic third-party audits for continuous accountability",
        feature6: "Direct access to Brazil’s growing voluntary carbon market"
      }
    },
    hectaresBanner: {
      unit: "hectares",
      pipeline: "124000 ha of projects funded"
    },
    howItWorksNew: {
      title: "How It Works?",
      step1: {
        title: "Projects are structured in stages",
        subtitle: "Each stage must be completed and verified before the next begins."
      },
      step2: {
        title: "Capital is released only after verification",
        subtitle: "Funds move forward only when milestones are met."
      },
      step3: {
        title: "Assets or revenues are distributed transparently",
        subtitle: "Carbon credits, yields, or cash flows are delivered on-chain."
      }
    },
    ecosystem: {
      title: "Our Ecosystem",
      investInProjects: {
        title: "Invest in projects",
        description: "Invest directly in verified bioeconomy projects and track progress through each stage.",
        cta: "Explore projects"
      },
      bctToken: {
        title: "BCT token",
        description: "Lock BCT to participate in the community and earn rewards linked to real carbon credits and agroforestry yields.",
        cta: "Learn more"
      },
      reforestationGame: {
        title: "Reforestation Game",
        description: "An educational idle game where players restore ecosystems, learn about carbon sequestration, and earn rewards for participation.",
        cta: "Play game",
        comingSoon: "Coming soon"
      }
    },
    roadmap: {
      title: "Roadmap",
      q3_2025: "Tokenized carbon credit investments, agroforestry projects open for funding, permissioned secondary trading market.",
      q4_2025: "Multi-source carbon credit calculation (satellite + field plots + ecosystem simulations), end-to-end project listing for developers, stage-gated investor capital protection.",
      q1_2026: "Independent-auditor workflow & console, investor returns simulator, approval-gated developer pipeline.",
      q2_2026: "Real-time project pricing engine, project timeline & cost-calculator engines, KYC-verified investor onboarding, platform token & staking.",
      q3_2026: "Auto-generated project documentation (PDDs), methodology selection & generation workflow, direct integration with multiple certifiers, first production tokenized credit issuance.",
      q4_2026: "Hardware-attested biochar credit generation, energy credit tokenization, community agroforestry investment pilot, TradFi fiat ↔ digital-asset on/off-ramp, tokenized real-world-asset secondary trading."
    },
    faqNew: {
      title: "Frequently Asked Questions",
      q1: {
        title: "How can I invest in a project on the platform?",
        answer: "Go to the Projects page and choose a project you like. You can click Invest directly on the project card or open the project details page. Connect your wallet, make sure you have USDC, choose the amount, and confirm your investment. That’s it."
      },
      q2: {
        title: "What do I need to invest?",
        answer: "You need a digital wallet with USDC. When you later claim funds or assets, you will also need to complete a KYC (identity verification) step."
      },
      q3: {
        title: "Where can I see my investments and assets?",
        answer: "All your investments, tokens, and claims are visible in your dashboard and in the side panel of the app. Everything is tracked in one place."
      },
      q4: {
        title: "Can I pay using a bank transfer?",
        answer: "Not yet. Currently, we support USDC only. We are actively working on integrating fiat on/off ramps so bank transfers will be possible in the future."
      },
      q5: {
        title: "How do I know if a project is unsuccessful?",
        answer: "If a project does not meet its milestones, this will be clearly shown on the project page. A Claim button will also appear on the project card."
      },
      q6: {
        title: "If a project fails, how do I get a refund?",
        answer: "If a project fails at a stage where funds were not spent, a Claim button will appear. You click Claim, send back the tokens you received when investing, and the smart contract releases your remaining funds to you."
      },
      q7: {
        title: "Does Brazil Carbon guarantee the validity of tokenized carbon credits?",
        answer: "Carbon credit tokens are issued by our certification partners, based on their verified methodologies. Brazil Carbon provides the investment infrastructure, while credit validity comes from the certifiers."
      },
      q8: {
        title: "How secure is a digital wallet?",
        answer: "Digital wallets use strong encryption to protect your assets. As long as you keep your private keys safe, only you can access your funds. Unauthorized access is practically impossible without your keys."
      },
      q9: {
        title: "What are the advantages of using a digital wallet?",
        answer: "A wallet gives you full control over your assets. You can receive funds instantly, pay very low fees, and track everything transparently — without relying on banks or intermediaries."
      },
      q10: {
        title: "Can I sign in with Google or Apple?",
        answer: "Yes. You can connect a wallet using Google or Apple login. Just click Connect Wallet and choose the option you prefer."
      },
      q11: {
        title: "What is agroforestry and where does the value come from?",
        answer: "Agroforestry is a farming system where crops grow together with trees, as part of a forest ecosystem. Crops like cacao and coffee grow better under shade, making this system more productive and resilient. Agroforestry keeps the soil healthy, retains moisture, avoids chemicals, and produces multiple crops at the same time — such as cacao, açaí, and cupuaçu. Investors earn returns while supporting biodiversity and healthy ecosystems."
      },
      q12: {
        title: "How is value generated for investors?",
        answer: "Farmers sell their products in the market. After sales, profits are deposited into a smart contract. Investors claim their share using the tokens they received when investing."
      },
      q13: {
        title: "Are you working with companies that need carbon credits?",
        answer: "Yes. Brazil is introducing regulations that will increase demand for locally issued carbon credits. We also work with multinational companies that need credits for compliance or voluntary offsetting. Credits can be sold on marketplaces or retired."
      },
      q14: {
        title: "Do companies “burn” carbon credits?",
        answer: "Yes. Carbon credits are retired by the certifier when used for offsetting. Brazil Carbon does not retire credits — we enable investment and access."
      },
      q15: {
        title: "Where does the yield from agroforestry projects come from?",
        answer: "The yield comes from the sale of agricultural products grown on the farm, such as cacao, coffee, or açaí. These real sales generate the revenue distributed to investors."
      },
      q16: {
        title: "Do you have a token for each crop?",
        answer: "Yes. When you invest, you receive crop-specific tokens. These tokens let you claim your share of revenues and can also be sold to other investors."
      }
    }
  },
  projectsGrid: {
    type: "Type",
    learnMore: "Learn more",
    biddingClosed: "Bidding closed",
    biddingOpen: "Bidding open",
    upcomingOffer: "Upcoming offering",
    by: "by",
    totalCreditsOffered: "Total credits offered",
    certificate: "Certificate"
  },
  notFound: {
    title: "Sorry, this page doesn’t exist",
    description: "We searched high and low but couldn't find what you're looking for. Let's find a better place for you to go.",
    returnHome: "Return home",
    getHelp: "Get some help"
  },
  dashboardPage: {
    withdrawCredits: "Withdraw credits",
    investment: "Investment",
    publicSale: "Public sale",
    profit: "Profit",
    registered: "Registered",
    invested: "Invested",
    owned: "Owned",
    creditsSold: "Credits sold",
    cardonCredit: "Carbon credits",
    projectStage: "Project stage",
    myAllocation: "My allocation",
    myCredit: "My credits",
    totalProjects: "Total projects",
    projects: "projects",
    seeProjectDetails: "See project details",
    fundRaised: "Fund raised",
    registeredInvestors: "Registered investors",
    creditSold: "Credits sold",
    nextAudit: "Next Audit",
    projectEnded: "Project ended",
    unlockedFunds: "Unlocked funds",
    nextUnlock: "Next unlock",
    balance: "Balance",
    contract: "Contract",
    offsetting: "Offsetting",
    fundsRaised: "Funds raised",
    nextAuditL: "Next audit",
    paidAmount: "Paid amount",
    creditsAllocated: "Credits allocated",
    expectedROI: "Expected ROI",
    investedStage: "Invested stage",
    fundingStage: "Funding Stage"
  },
  carbonCycle: {
    offering: "Offering",
    registration: "Registration",
    live: "Live",
    ended: "Ended",
    projectDevelopment: "Project Development",
    certification: "Certification",
    audit: "Audit"
  },
  guidePage: {
    fullVideo: "Full video",
    rootBreadcrumb: "Brazil Carbon help center",
    howHelp: "How can we help you?",
    askQuestion: "Ask a question"
  },
  multiSig: {
    alreadyApproveWithdraw: "You have already approved withdrawal",
    alreadyApproveStartAudit: "You have already approved start audit",
    alreadyApproveAuditSuccess: "You have already approved audit success",
    alreadyApproveAuditUnsuccess: "You have already approved audit unsuccess",
    alreadyApproveCancelUnsuccess: "You have already approved cancel unsuccessful audit",
    waitingApprove: "Waiting for approval from other signers",
    withdrawalOwnerSuccessful: "Withdrawal successful! Owner balance has been updated.",
    withdrawalDeveloperSuccessful: "Withdrawal successful! Developer balance has been updated.",
    withdrawalPartnerSuccessful: "Withdrawal successful! Partner balance has been updated."
  },
  auditorPage: {
    audits: "Audits",
    inProgress: "In progress",
    successfull: "Succcessfull",
    unsuccessful: "Unsuccessful"
  },
  newDashboard: {
    ownedProjects: "Owned projects",
    allTokens: "All Tokens",
    cardonCredit: "Cardon Credits",
    totalProjects: "Total Projects",
    projectsOwned: "projects owned",
    projects: "Projects",
    assets: "Assets",
    investments: "Investments"
  },
  newCard: {
    certificationBody: "Certification Body",
    certificateId: "Certificate ID",
    issuanceDate: "Issuance Date",
    creditsOwned: "Credits Owned",
    certificationReport: "Certification Report",
    learnMore: "Learn More",
    sell: "Sell",
    claim: "Claim",
    claimBenefit: "Claim benefit",
    benefitClaimSuccess: "Benefit claimed successfully",
    benefitClaimError: "Benefit claim failed",
    availableToClaim: "Available to claim"
  },
  sellForm: {
    selectYear: "Please select a year",
    unitPrice: "Unit price",
    owned: "Owned",
    putOnSale: "Put on sale",
    enterCreditsAmount: "Enter credits amount",
    carbonCredits: "Carbon credits",
    agroProducts: "Agroforestry products",
    creditsAvailable: "Credits available",
    sell: "Sell",
    cancel: "Cancel",
    listedOnSaleSuccess: "Listed on sale",
    listedOnSaleError: "Error listing on sale"
  },
  saleSideContainer: {
    buyText: "You have bought {showAmount} {symbol}.",
    seeTransaction: "See Transaction",
    buyText2: "Your purchase in {name} was successful.",
    backToBuy: "Back to Buy",
    selectYear: "Select Year",
    noTokensAvailable: "There are no tokens available for sale",
    buyVintageCredits: "Buy vintage credits",
    buyCredits: "Buy credits",
    enterUsdcAmount: "Enter amount",
    usdcAvailable: "{amount} USDC available",
    usdc: "USDC",
    carbonCredit: "Carbon Credits",
    AgroforestryProducts: "Agroforestry Products",
    loginToBuy: "Login to buy credits",
    insufficientFunds: "Insufficient funds",
    buy: "Buy",
    vintage: "Vintage",
    buyCarbonCredits: "Buy carbon credits",
    batch: "Batch",
    saleClosed: "Sale closed",
    saleClosedText: "Unfortunately, the sale period has ended."
  },
  investSideContainer: {
    investmentClosed: "Investment closed",
    agroQuestionTooltip: "Conversion rate from estimated agroforestry products to USDC",
    questionTooltip: "Conversion rate from estimated credits to actual issued credits",
    creditsToClaim: "You have {amount} credits to claim!",
    usdcToClaim: "You have {amount} USDC to claim!",
    invest: "Invest",
    loginAgain: "Log in",
    sessionExpired: "Your session expired. Log in to continue.",
    investmentUnavailable:
      "Investment is temporarily unavailable. Please try again later or contact support if the issue continues.",
    roi: "{percentage}% ROI",
    certification: "Certification",
    enterUsdcAmount: "Enter amount",
    usdcAvailable: "{amount} USDC available",
    usdc: "USDC",
    carbonCredit: "carbon credits",
    agroforestryProducts: "agroforestry products",
    insufficientFunds: "Insufficient funds",
    investText: "You have invested {showAmount} {symbol}.",
    seeTransaction: "See transaction",
    investText2: "Your investment in {name} was successful.",
    backToInvest: "Back to invest",
    claimCredits: "Claim credits",
    youReceived: "You received {showAmountExchange} {symbol}",
    exchangeSuccess: "You have successfully exchanged carbon credits.",
    close: "Close",
    rate: "rate",
    credits: "credits",
    enterAmountUSDCWarning: "Please enter USDC amount first",
    enterAmountCreditWarning: "Please enter credits amount first",
    enterAmountAgroWarning: "Please enter agroforestry amount first"
  },
  overviewTab: {
    satelliteView: "Satellite view",
    plantingArea: "Planting area",
    visitMethodologyWebsite: "Visit methodology website",
    description: "Description",
    coBenefitors: "Co-benefitors",
    forestCoverMap: "Forest cover map",
    forestVisualizer: {
      unavailable: "Annual satellite observation unavailable.",
      yearToDate: "year to date",
    },
    developers: "Developers",
    developedBy: "Developed by",
    certifiedBy: "Certified by",
    files: "Files",
    fileName: "File",
    location: "Location",
    projectSize: "Project size",
    forestCover: "Forest cover",
    methodologyApprovedBy: "Methodology approved by",
    hectares: "hectares",
    hectare: "hectare",
    methodology: "Methodology",
    projectArea: "Project Area",
    partners: "Partners",
    notCalculatedYet: "Not calculated yet",
    metrics: {
      project_area_ha: "Project area",
      land_tenure_status: "Land ownership",
      crediting_period_years: "Modeling horizon",
      methodology_code: "Methodology",
      removal_pathway: "Removal pathway",
      country_iso: "Country",
      credit_schedule_label: "Credit schedule",
      methane_abatement_activity: "Abatement activity",
      community_service_type: "Service type",
      energy_asset_activity: "Asset / activity",
    },
    metricValues: {
      years: "{count} years",
    },
    landownerCompensation: {
      title: "Landowner compensation",
      included: "Investor-funded landowner/co-beneficiary compensation is included as a separate project cost.",
      cap: "Maximum budget",
      monthly: "Monthly amount",
      months: "Months",
      payoutStart: "Payout start",
      allocation: "Allocation",
      projectStart: "Project start",
      afterStage: "After year {year} {stage}",
      allocationUniform: "Distributed across stages",
      allocationUpfront: "Upfront escrow",
      refundPolicy: "Earned compensation is a nonrefundable operating expense. Unearned future compensation remains refundable under the project failure policy."
    }
  },
  environmentTab: {
    biodiversityDescription: "Reflects the area’s position in a ranking of species richness and diversity.",
    biodiversityScore: "Biodiversity\nIndex",
    preventedDeforestation: "Prevented deforestation\nin hectares / year",
    ecosystemServicesValue: "Ecosystem Services\nValue:",
    carbonSequestration: "Carbon Sequestration\nPotential in tons / year",
    deforestationCauses: "Deforestation\nCauses",
    deforestationContributors: "Deforestation\nContributors",
    current: "Current",
    forestCover: "Forest Cover",
    metrics: {
      current_biomass_t: "Current biomass",
      biomass_uncertainty_pct: "Biomass uncertainty",
      total_credits_forecast_tco2e: "Total credit forecast",
      prevented_deforestation_ha_yr: "Prevented deforestation",
      avg_avoided_credits_forecast_tco2e_yr: "Avoided credits / yr",
      total_co2_sequestration_forecast_tco2e: "Sequestration forecast",
      avg_annual_sequestration_forecast_tco2e: "Sequestration / yr"
    }
  },
  carbonTab: {
    collectingFunds: "Receiving",
    totalCarbonCredits: "Total Carbon\nCredits",
    finalCarbonCreditPrice: "Final Carbon\nCredit Price",
    totalCarbonCreditValuation: "Total Carbon Credit\nValuation",
    investmentPrices: "Carbon credit investment prices depend on the stage:",
    filled: "Filled",
    future: "Future",
    currentPhase: "Current phase",
    current: "Current",
    currentStage: "Current stage",
    invest: "Invest",
    priceText: "Price",
    costText: "Cost",
    roiText: "ROI"
  },
  investmentTab: {
    pricePerKilo: "Price per kilo",
    additionalRevenue: "Total additional revenue generated",
    fundingRequirements: "Funding Requirements:",
    roi: "{value}% ROI",
    stageCostBreakdown: "Stage Cost Breakdown",
    otherCosts: "Others",
    baseCostBreakdown: "Base Cost Breakdown",
    roiWithCost: "{roi}% ROI ${cost}",
    filled: "Filled",
    future: "Future",
    currentPhase: "Current phase",
    currentStage: "Current stage"
  },
  roiChart: {
    inflation: "Inflation",
    total: "Total",
    cumulative: "Cumulative ROI"
  },
  auditCardNew: {
    audit: "Audit",
    years: "Years",
    year: "Year",
    stageForAudit: "Stage for audit",
    startStage: "Start {stageName}",
    noStageName: "No stage name",
    unsuccessful: "Unsuccessful",
    successful: "Successful",
    auditWindowOpen: "Audit window open",
    actionRequired: "Action required",
    acceptAssignment: "Accept assignment",
    releaseFunds: "Release funds",
    lifecycleActions: "Auditor lifecycle actions",
    action: "Action",
    stage: "Stage",
    submitAction: "Prepare and sign action",
    actionCompleted: "Auditor action completed.",
    amount: "Amount",
    claimId: "Claim ID (bytes32)",
    evidenceHash: "Evidence hash (bytes32)",
    bindingHash: "Binding hash (bytes32)",
    planHash: "Plan hash (bytes32)",
    payee: "Compensation payee",
    yearValues: "Years (comma-separated)",
    stageIndexes: "Stage indexes (comma-separated)",
    allocations: "Allocations (comma-separated)",
    cap: "Total compensation cap",
    seriesId: "Series ID",
    amountWhole: "Whole credits to issue",
    creditsWhole: "Whole credits to finalize",
    registryId: "Registry ID",
    vintageYear: "Vintage year",
    hostCountry: "Host country (bytes2)",
    capWhole: "Whole-credit cap",
    registryReference: "Registry credit reference or URL",
    routeReference: "Methodology or asset-route reference",
    creditEvidenceReference: "Certification evidence URL or reference",
    confirmProjectFailure:
      "I understand that marking this project failed is irreversible.",
    creditIssuance: {
      title: "Issue credits — Year {year}",
      yearBadge: "Year {year}",
      certifier: "Certifier",
      methodology: "Methodology",
      certifiedCredits: "Credits to issue (whole tCO₂e)",
      predictedCredits: "Prefilled from the projected amount: {credits} whole tCO₂e. Edit before creating the series.",
      referencePlaceholder: "Paste a URL, reference, or existing 0x hash",
      referenceHelp: "Use the public certification or registry record for this credit issuance.",
      registryIdHelp: "Enter the complete external ID. The compact on-chain identifier is generated automatically.",
      registryIdRequired: "Enter the external registry or certificate ID.",
      wholeCreditsRequired: "Enter a positive whole-credit amount.",
      exceedsSeriesCap: "The amount cannot exceed the series cap.",
      registryEvidenceRequired: "Add the registry ID and certification record before issuing credits.",
      evidenceReferenceRequired: "Enter the certification evidence URL, reference, or existing hash.",
      descriptions: {
        verifiedCreditSeriesCreate: "Confirm the registry evidence and create the on-chain series.",
        creditBindingApproval: "Approve the series binding for this project year.",
        verifiedCreditIssue: "Issue the verified credits into settlement custody.",
        creditYearFinalize: "Finalize the year so investors can claim when its claim date opens."
      }
    },
    confirmedBlock: "Confirmed at block {block}",
    mode: {
      auditor_required: "Manual auditor wallet",
      backend_api: "Connected auditor API",
      onchain: "On-chain auditor contract"
    },
    modeStatus: {
      auditor_required: "Actions require the assigned auditor wallet.",
      backend_api:
        "The connected auditor service submits actions. Browser signing is disabled.",
      onchain:
        "The auditor contract submits actions on-chain. Browser signing is disabled."
    },
    actions: {
      stageRelease: "Release stage principal",
      projectFailure: "Mark project failed",
      stageRefundFinalize: "Finalize stage refund",
      compensationPlanConfigure: "Configure compensation plan",
      compensationAccrual: "Accrue stage compensation",
      compensationStop: "Stop compensation",
      creditBindingApproval: "Approve credit binding",
      verifiedCreditSeriesCreate: "Create verified-credit series",
      verifiedCreditIssue: "Issue verified credits",
      creditYearFinalize: "Finalize credit year"
    },
    releaseStage: "Year {year}, stage {stage}",
    waitingForFundedStage: "Waiting for a funded stage.",
    waitingForDeveloperWithdrawal: "Waiting for the developer to withdraw the released funds.",
    loadingStatus: "Loading audit status…",
    preparingAction: "Preparing wallet action…",
    actionUnavailable: "Audit action is temporarily unavailable.",
    auditorLoginRequired: "Log in with the assigned auditor wallet.",
    assignmentAccepted: "Auditor assignment accepted.",
    fundsReleased: "Stage funds released for developer withdrawal.",
    actionPendingVerification: "Transaction submitted. Status is updating.",
    insufficientGasFunds:
      "Your wallet does not have enough ETH to pay the network fee for this audit action.",
    actionFailed: "The audit action could not be completed. Please try again."
  },
  AuditorPageNew: {
    inProgress: "In Progress",
    successful: "Successful",
    unsuccessful: "Unsuccessful",
    auditedProjects: "Audited Projects",
    activeAudits: "Active audits",
    waitingAuditWindow: "Waiting for audit window",
    completedAudits: "Completed audits",
    connectTitle: "Connect auditor wallet",
    connectDescription:
      "Connect the wallet registered by the admin to view assigned projects and sign audit actions.",
    connectWallet: "Connect auditor wallet",
    connectHint:
      "Use the same wallet address configured on the auditor record.",
    connectNotRegistered:
      "This wallet or email is not registered as an auditor. Ask an admin to add the auditor record, then try again."
  },
  optionTabs: {
    overview: "Overview",
    environment: "Environment",
    status: "Status",
    activities: "Activities",
    investment: "Investment",
    yield: "Yield",
    financials: "Financials"
  },
  stageNames: {
    design: "Design",
    validation: "Validation",
    monitoring: "Monitoring",
    verification: "Verification",
    issuance: "Certification",
    certification: "Certification",
    community: "Community"
  },
  projectUsersStep: {
    title: "Project Users",
    owners: "Owners",
    addOwner: "Add Owner",
    removeOwner: "Remove",
    name: "Name",
    walletAddress: "Wallet address",
    allocation: "Allocation(%)",
    coBenefitors: "Co-Benefitors",
    addBenefitor: "Add Benefitor",
    allocationOfCredits: "Allocation of carbon credits",
    landTenureStatus: "Land tenure status",
    landOwnershipStatus: "Land Ownership Status",
    landOwnershipPlaceholder: "Select tenure type",
    landOwnershipHelper: "Proposed addition derived from Brazilian land-tenure conventions (CCIR/matrícula, posse, assentamento, terra indígena, quilombola, UC, concessão).",
    landStatusOptions: {
      "0": "Public",
      "1": "Private",
      "2": "Concession",
      private_title: "Private",
      possession: "Possession (informal)",
      agrarian_settlement: "Agrarian reform settlement",
      indigenous_territory: "Indigenous territory",
      quilombola: "Quilombola community",
      conservation_unit: "Conservation unit (RPPN, APA, …)",
      forest_concession: "Forest concession",
      other: "Other (specify)"
    },
    biome: "Biome",
    biomeOptions: {
      "0": "Amazon rainforest",
      "1": "Caatinga",
      "2": "Cerrado",
      "3": "Atlantic Forest",
      "4": "Pantanal",
      "5": "Pampa"
    }
  },
  createInvestForm: {
    investmentCreated: "Investment created successfully",
    basicInfo: "Basic Info",
    commissions: "Commissions (%)",
    usdcFee: "Usdc fee",
    costs: "Costs",
    year: "Year {year}",
    supply: "Supply",
    finalPrice: "Final price",
    uploadPhoto: "Upload Forest Cover Photo (Max 1 JPG, JPEG or PNG)",
    design: {
      title: "Design",
      cost: "Design Cost",
      description: "Design Description"
    },
    validation: {
      title: "Validation",
      cost: "Validation Cost",
      description: "Validation Description"
    },
    monitoring: {
      title: "Monitoring",
      cost: "Monitoring Cost",
      description: "Monitoring Description"
    },
    verification: {
      title: "Verification",
      cost: "Verification Cost",
      description: "Verification Description"
    },
    issuance: {
      title: "Issuance",
      cost: "Issuance Cost",
      description: "Issuance Description"
    },
    navigation: {
      close: "Close",
      back: "Back",
      continue: "Continue",
      createInvest: "Create Invest"
    },
    startInvestmentProcess: "Start investment process"
  },
  errorMessages: {
    missingTotalSupply: "Please enter a valid total supply for year {year}.",
    missingFinalPrice: "Please enter a valid final price for year {year}.",
    totalSupplyExceeded: "Total supply cannot exceed the project supply. Maximum allowed: {max}.",
    missingDescription: "Please enter a description for {field} in year {year}.",
    missingForestPhoto: "Please upload a forest cover photo for year {year}.",
    enterValidCosts: "Please enter a valid cost greater than 0 for all stages"
  },
  forestCover: {
    "1": "Tropical Rainforest",
    "2": "Tropical Dry Forest",
    "3": "Montane (Cloud) Forest",
    "4": "Atlantic Forest",
    "5": "Subtropical Forest",
    "6": "Mangrove Forest",
    "7": "Flooded Forest (Várzea & Igapó)",
    "8": "Savanna-Forest Mosaic",
    "9": "Temperate Forest",
    Dense: "Tropical Rainforest"
  },
  landStatus: {
    "0": "Public",
    "1": "Private",
    "2": "Concession"
  },
  activitiesSection: {
    activity: "Activity",
    addActivity: "Add Activity",
    updateActivities: "Update Activities",
    activityNamePlaceholder: "Activity Name",
    descriptionPlaceholder: "Description",
    save: "Save"
  },
  developerWithdrawal: {
    available: "Funds available to withdraw",
    stage: "Year {year}, stage {stage}",
    description: "The certifier released this stage's principal to the project developer.",
    withdraw: "Withdraw",
    success: "Funds withdrawn successfully.",
    pending: "Transaction submitted. Withdrawal status is updating.",
    failed: "The withdrawal could not be completed. Please try again.",
    unavailable: "Withdrawal is temporarily unavailable. Please try again shortly."
  },
  stageActions: {
    sign: "Sign {stage}",
    withdraw: "Withdraw from {stage}",
    withdrawalPendingApproval: "Withdrawal pending approval"
  },
  signDialog: {
    investmentProcessFinished: "Project investment process finished",
    stageRequiresAudit: "Needs first audit stage {stage}",
    stageRequiresDeveloper: "This stage requires to be developer",
    stageRequiresAuditor: "This stage requires to be auditor",
    stageRequiresCertifierOrDeveloper: "This stage requires to be {role}",
    certifier: "certifier",
    developer: "developer",
    stageNotCompleted: "Stage not completed",
    withdrawSuccess: "Withdraw success",
    signError: "Error on sign",
    remoteSensingImageHash: "Remote Sensing Image Hash",
    reportHash: "Report Hash",
    deforestationRateM2: "Deforestation Rate (m²)",
    landDegradationRateM2: "Land Degradation Rate (m²)",
    abovegroundCarbonStockKg: "Aboveground Carbon Stock (Kg)",
    belowgroundCarbonStockKg: "Belowground Carbon Stock (Kg)",
    soilOrganicCarbonStockKg: "Soil Organic Carbon Stock (Kg)",
    deadOrganicMatterKg: "Dead Organic Matter (Kg)",
    landUseOpportunityCost: "Land Use Opportunity Cost",
    leakageKg: "Leakage (Kg)",
    verifierName: "Verifier Name",
    verifierLicense: "Verifier License",
    verificationReportHash: "Verification Report Hash",
    verifiedEmissionReductionsKg: "Verified Emission Reductions (Kg)",
    verificationDate: "Verification Date",
    certificationBody: "Certification Body",
    certificationNumber: "Certification ID",
    certificationReport: "Certification Report URL",
    creditsIssued: "Credits Issued",
    issuanceDate: "Issuance Date",
    creditSerialStart: "Credit Serial Start",
    creditSerialEnd: "Credit Serial End",
    certificationStage: "Certification Stage",
    required: "This field is required",
    invalidNumber: "Please enter a valid number",
    invalidDate: "Please enter a valid date",
    signed: "Stage signed successfully",
    withdrawn: "Stage withdrawn successfully",
    updated: "Stage updated successfully",
    saved: "Stage data saved",
    errorOnWithdraw: "The withdrawal could not be completed. Please try again.",
    withdrawUnavailable: "Withdrawal is temporarily unavailable. Please try again shortly."
  },
  investmentCostsStruct: {
    validation: {
      _label: "Validation Costs",
      field_visit: "Field Visit",
      satellite_analysis: "Satellite Analysis",
      "3rd_party_validation": "3rd Party Validation",
      "legal_&_admin": "Legal & Admin",
      certifier_registration: "Certifier Registration",
      registration_fee: "Registration Fee"
    },
    monitoring: {
      _label: "Monitoring Costs",
      travel: "Travel",
      "accommodation_&_meals": "Accommodation & Meals",
      personnel: "Personnel",
      data_processing: "Data Processing"
    },
    verification: {
      _label: "Verification Costs",
      "site_visit_&_field_audit": "Site Visit & Field Audit",
      "report_submission_&_compliance": "Report Submission & Compliance",
      "legal_&_admin": "Legal & Admin"
    },
    issuance: {
      _label: "Issuance Costs",
      verification_review: "Verification Review",
      carbon_credit_issuance_fee: "Carbon Credit Issuance Fee",
      annual_fee: "Annual Fee",
      insurance: "Insurance",
      submission_fee: "Submission Fee"
    }
  },
  stageNamesAbr: {
    design: "Des.",
    validation: "Val.",
    monitoring: "Mon.",
    verification: "Ver.",
    issuance: "Cert.",
    certification: "Cert.",
    finalPrice: "Final Price"
  },
  agroStageNamesAbr: {
    planning: "Plan.",
    site_preparation: "Prep.",
    planting: "Plant.",
    maintenance: "Maint.",
    harvest: "Harv.",
    value_addition: "Val.Add.",
    marketing: "Mkt.",
    finalPrice: "Final Price",
    cultureCost: "Cost"
  },
  developerForm: {
    full_name: "Full Name",
    email: "Email",
    web_page: "Web Page",
    company_registry_number: "Company Registry Number",
    date_of_incorporation: "Date of Incorporation",
    phone: "Phone",
    wallet_address: "Wallet Address",
    logo: "Company Logo"
  },
  tokenPage: {
    fifthSectionCta: "Start farming",
    tokenSupply: "Token supply",
    tokenAmount: "850M",
    projectSize: "Current project size \nin hectares",
    projectAmount: "32",
    sequestrationRate: "Carbon sequestration rate \nper token",
    sequestrationAmount: "124000 ha",
    sequesterSecondLine1: "Lock BCT, capture CO₂,",
    sequesterSecondLine2: "receive real world yields.",
    hero: {
      title: "Farm CO₂ and earn carbon credits\nand agroforestry tokens",
      stake: "Farm CO2",
      grow: "Grow your forest"
    },
    thirdSection: {
      title: "How it works",
      gridTitle1: "1",
      gridTitle2: "2",
      gridTitle3: "3",
      gridTitle4: "4",
      gridDescription1: "Buy BCT tokens and lock them to receive rewards",
      gridDescription2: "The funds from tokens are invested into verified projects.",
      gridDescription3: "Forests capture CO₂ producing carbon credits and agroforestry farms yield cocoa, açaí.",
      gridDescription4: "Receive carbon credits and agro tokens which can convert to USDC."
    },
    secondSectionTitle: "Interactive Forest Simulation",
    secondSectionDescription: "Boost your rewards by growing your forest using 50+ Amazonian tree species, improve its biomass, biodiversity, and ecosystem health, and unlock rare species as your stake increases.",
    earningModelTitle: "Earning Model & Risk Protection",
    earningModel: {
      item1Title: "Real asset backing",
      item1Description: "Land and agroforestry products",
      item2Title: "Recurring revenue streams",
      item2Description: "Carbon credits are streamed by the second",
      item3Title: "Increasing APR",
      item3Description: "Tied to expanding asset base"
    },
    sixthSectionTitle: "Interactive Forest Simulation",
    sixthSectionDescription: "“I love it! I never had a green thumb and now I know so much about forest”"
  },
  transactionActions: {
    invest: "Invest",
    buy: "Buy",
    sell: "Sell",
    claim: "Claim"
  },
  agroStageNames: {
    planning: "Planning & Design",
    site_preparation: "Site preparation",
    planting: "Planting & establishment",
    maintenance: "Maintenance and care",
    harvest: "Harvest & Post-Harvest",
    value_addition: "Value addition",
    marketing: "Marketing and distribution",
    labor: "Labor",
    inputs: "Inputs",
    tools: "Tools & Equipment",
    services: "Services/Consultancy",
    infrastructure: "Infrastructure",
    design: "Design",
    validation: "Validation",
    monitoring: "Monitoring",
    verification: "Verification",
    issuance: "Certification",
    certification: "Certification",
    cultureCost: "specific costs"
  },
  agroCarbonTab: {
    revenueGrowth: "Revenue Growth",
    yoyGrowthRate: "YoY growth rate",
    totalProduce: "Total Produce",
    currentProduction: "Current Production",
    inKg: "In Kg/Year",
    sellingPricePerKg: "Selling Price per Kg",
    production: "Production"
  },
  farmerPage: {
    selectSpeciesYear: "Select species and year",
    selectSpecies: "Select species",
    selectYear: "Select year",
    selectedYear: "Selected year",
    depositFor: "Deposit for",
    finalizeDepositFor: "Finalize deposit for",
    title: "Farmer Projects",
    activeProjects: "Active projects",
    startNewProject: "Start a new project",
    draftTitleFallback: "Untitled project",
    jobsCreated: "jobs created",
    edit: "Edit",
    seeProjectPage: "See page",
    deposit: "Deposit",
    updateProduction: "Update production",
    updateStage: "Update stage",
    enterDepositAmount: "Enter deposit amount",
    awaitingApproval: "Awaiting approval"
  },
  farmerForm: {
    enterYearlyCost: "Enter at least one cost entry for year{suffix} {years}.",
    tellUsTitle: "Tell us more about your project",
    tellUsDescription: "Whether you're maintaining an ancestral agroforest or launching a new food forest system, this form helps us understand your story, structure your data, and prepare it for impact investment.",
    startApplication: "Start application",
    step1Title: "Submit your project",
    step1Description: "Share basic info, species data, and financials.",
    step2Title: "We review & refine",
    step2Description: "Our team may contact you to clarify or enrich your data.",
    step3Title: "Ready for funding",
    step3Description: "Once verified, your project becomes eligible for climate-aligned investment.",
    sidebarTitle: "Project Analysis",
    sidebarSubtitle: "Complete the form to see your analysis",
    submit: "Submit",
    save: "Save",
    previous: "Previous",
    continue: "Continue",
    finishCosts: "Finish Costs",
    nextSpecies: "Next Species",
    seeAnalysis: "See Analysis",
    stepProduction: {
      productionDelay: "Production delay (months)",
      inKg: "In Kg/Year",
      sellingPricePerKg: "Selling price",
      currentProduction: "Current production",
      currentHarvest: "Current harvest",
      nextYearProduction: "Production (next year)",
      production: "Production",
      years: "Years",
      expectedAmount: "Expected amount"
    },
    stepPlanting: {
      trees: "Trees",
      plantingAreaSize: "Planting Area Size",
      areaPlaceholder: "00.00 hectares",
      uploadKML: "Upload KML File",
      photos: "Photos",
      photoHint: "Please include photos of the production",
      speciesPlaceholder: "Species name",
      quantityPlaceholder: "Number of trees",
      addTree: "Add tree"
    },
    stepOverview: {
      speciesPlanted: "Species planted",
      expansion: "Expansion",
      maintenance: "Maintenance",
      value_addition: "Value Addition",
      projectOwner: "Project owner",
      projectOwnerPlaceholder: "Enter project owner",
      projectTitle: "Project Title",
      projectTitlePlaceholder: "Enter project title",
      projectType: "Project type",
      learnMore: "learn more",
      jobsCreated: "Number of jobs created",
      jobsPlaceholder: "00.00",
      biome: "Biome",
      selectBiome: "Select project biome",
      speciesCount: "Number of species in the system",
      speciesPlaceholder: "00.00",
      state: "State",
      selectState: "Select state",
      city: "City",
      cityPlaceholder: "Enter city",
      investment: "Investment in R$",
      investmentCon: "Investment in USD$",
      investmentPlaceholder: "00.00",
      projectYears: "Project years",
      yearsPlaceholder: "Enter amount of years",
      photos: "Photos",
      photoHint: "Upload photos of the project area.",
      supportingDocuments: "Supporting documents",
      supportingDocumentsHint: "Attach any supporting documents for the project.",
      docHint: "Eg. Financial plan, planting design, map, photos",
      expansionDescription: "Creates new agroforestry production capacity.",
      maintenanceDescription: "Funds ongoing maintenance for existing production.",
      valueAdditionDescription: "Funds processing or other value-addition work.",
      description: "Project description",
      descriptionPlaceholder: "Enter project description"
    },
    stepCosts: {
      inputPlaceholder: "00.00",
      systemWide: "System wide {year}",
      culture: "{name} culture {year}",
      "Planning & Design": "Planning & Design",
      "Site preparation": "Site Preparation",
      "Planting & establishment": "Planting & Establishment",
      "Maintenance and care": "Maintenance and Care",
      "Harvest & Post-Harvest": "Harvest & Post-Harvest",
      "Value addition": "Value Addition",
      "Marketing and distribution": "Marketing and Distribution",
      "Site Preparation": "Site Preparation",
      "Planting & Establishment": "Planting & Establishment",
      "Maintenance & Care": "Maintenance & Care",
      "Value Addition": "Value Addition",
      "Marketing & Distribution": "Marketing & Distribution",
      Labor: "Labor",
      Inputs: "Inputs",
      Materials: "Materials",
      "Tools & Equipment": "Tools & Equipment",
      "Services/Consultancy": "Services / Consultancy",
      Infrastructure: "Infrastructure",
      repeatYearly: "Repeats yearly",
      recurring: "Recurring",
      oneTime: "One-time",
      toolName: "Item name",
      toolCost: "Cost",
      addTool: "Add tool or equipment",
      removeTool: "Remove",
      noTools: "No tools added"
    },
    stepBiome: {
      deforestedArea: "Area deforested in biome",
      plantSpecies: "Number of plant species in biome",
      animalSpecies: "Number of animal species in biome"
    },
    stepImpact: {
      cropDiversity: "Number of crop diversity in the system",
      waterAvailability: "Increase in water availability on the soil",
      soilFertility: "Increase of life/fertility on the soil",
      faunaIncrease: "Increase of fauna in the area",
      landConversion: "Conversion of pasture/agriculture land to agroforestry",
      foodProduction: "Increase in regenerative food production",
      riverbankRestoration: "Regeneration of forest along riverbanks",
      carbonSequestration: "Carbon sequestration above/below ground",
      landConversion_placeholder: "hectares",
      foodProduction_placeholder: "tons/year",
      riverbankRestoration_placeholder: "km",
      carbonSequestration_placeholder: "tons/year"
    },
    stepAnalisys: {
      avgYROI: "Average yearly ROI",
      increaseRevenue: "Increase in revenue",
      effectivePayback: "Effective Payback period",
      monthlyPayments: "Monthly payments",
      months: "months",
      investmentCost: "Investment cost",
      additionalRevenue: "Additional revenue",
      safePaybackStart: "Payback start",
      years: "years",
      chartTitle: "Revenue share forecast",
      chartSubtitleShort: "Short-term projects split revenue 50/50 until investors reach a 50% ROI cap.",
      chartSubtitleLong: "Long-term projects share revenue while the farmer covers costs after the chosen years.",
      farmerShare: "Farmer share",
      investorShare: "Investor share",
      yearlyBreakdownTitle: "Yearly revenue split",
      yearlyBreakdownDescription: "Projected payments, net revenue and investor/farmer split per year.",
      yearColumn: "Year",
      paymentsColumn: "Payments",
      revenueColumn: "Revenue",
      splitColumn: "Revenue split",
      noSplitData: "Not active yet",
      acceptTerms: "Accept terms and conditions",
      accept: "Accept",
      termsTitle: "Terms and Conditions",
      termsText1: "For the purposes of these Terms: 'Platform' means Brazil Carbon; 'Investor' means the person or entity investing in the Project through the Platform; 'Producer' means the farmer identified in the project registration; 'Project Area' and 'Total Repayable Amount' are those identified in the project registration approved on the Platform.\nThe Producer shall issue in favor of the Investor a Financial Rural Product Note (CPR-F) governed by Brazilian Law No. 8,929/1994, referencing the products to be obtained from the Project Area, in a face value not lower than the Total Repayable Amount. The CPR-F shall set maturities aligned with the harvest calendar and shall be registered with the competent registrar or notarial/registry office. When legally permissible, the CPR-F shall include:\n (a) fiduciary assignment of present and future receivables arising from the sale of such products; and\n (b) a pledge over crops or inventory of the financed production.\nThe Producer shall maintain the Project in ordinary course, follow technical recommendations, and shall not encumber or dispose of pledged assets without the Investor’s prior written consent.\nService fee: the Producer acknowledges and agrees that the Platform deducts a service fee from the amounts disbursed to the Producer, at the rate disclosed on the Platform at the time of contracting and recorded in the Project's smart contract.\nCustody and availability of funds: funds pending disbursement are held in smart contracts and may be temporarily allocated to third-party digital-asset protocols. Disbursements may be delayed, reduced, or prevented by events beyond the Parties' reasonable control, including security incidents (hacks or exploits) affecting smart contracts or third-party protocols, failure or insolvency of such protocols, loss of parity of the stablecoin used, blockchain network failures, and acts of government. Such events constitute force majeure (article 393 of the Brazilian Civil Code), and neither the Platform nor the Investor shall be liable for resulting losses, provided they act diligently to mitigate effects and recover funds.\nLimitation of liability: to the maximum extent permitted by law, the aggregate liability of the Platform and the Investor to the Producer is limited to direct damages and shall not exceed the amounts effectively contributed to the Project, excluding indirect damages and lost profits.\nDefault and cure: in case of breach by the Producer, the Investor shall send written notice and the Producer shall have 30 (thirty) days to cure the breach before enforcement of collateral or acceleration of the debt.\nThe Parties acknowledge that the collection, processing, storage, and sharing of personal data related to the Producer and associated individuals shall comply with the Brazilian General Data Protection Law (Lei nº 13.709/2018 – LGPD). Personal data shall be used exclusively for purposes connected to project verification, monitoring, payment processing, risk assessment, and regulatory compliance. The Producer grants consent for such processing and may request access, correction, or deletion of personal data as permitted by law. The Investor shall adopt appropriate administrative, technical, and security measures to safeguard personal data against unauthorized access, loss, or misuse.\nThis document is governed by the laws of the Federative Republic of Brazil. Any disputes shall be submitted to the courts of the judicial district where the Project Area is located. The Portuguese version of these Terms prevails over any translation; this English version is provided for convenience only.\n",
      termsText2: "For the purposes of these Terms: 'Platform' means Brazil Carbon; 'Investor' means the person or entity investing in the Project through the Platform; 'Producer' means the farmer identified in the project registration; 'Project Area' and 'Total Repayable Amount' are those identified in the project registration approved on the Platform.\nAll machinery, equipment, and fixtures financed under this Agreement shall be subject to fiduciary transfer of ownership (alienação fiduciária de bens móveis) in favor of the Investor, effective upon execution and registration with the competent authority. Until the Total Repayable Amount is fully settled, the Producer shall:\n (a) not sell, lease, remove, or encumber such assets;\n (b) maintain them in good working condition; and\n (c) maintain insurance naming the Investor as first-loss payee.\nIn the event of default, and to the extent permitted by law, the Investor may take possession of and sell the collateral, applying the proceeds to the outstanding balance.\nService fee: the Producer acknowledges and agrees that the Platform deducts a service fee from the amounts disbursed to the Producer, at the rate disclosed on the Platform at the time of contracting and recorded in the Project's smart contract.\nCustody and availability of funds: funds pending disbursement are held in smart contracts and may be temporarily allocated to third-party digital-asset protocols. Disbursements may be delayed, reduced, or prevented by events beyond the Parties' reasonable control, including security incidents (hacks or exploits) affecting smart contracts or third-party protocols, failure or insolvency of such protocols, loss of parity of the stablecoin used, blockchain network failures, and acts of government. Such events constitute force majeure (article 393 of the Brazilian Civil Code), and neither the Platform nor the Investor shall be liable for resulting losses, provided they act diligently to mitigate effects and recover funds.\nLimitation of liability: to the maximum extent permitted by law, the aggregate liability of the Platform and the Investor to the Producer is limited to direct damages and shall not exceed the amounts effectively contributed to the Project, excluding indirect damages and lost profits.\nDefault and cure: in case of breach by the Producer, the Investor shall send written notice and the Producer shall have 30 (thirty) days to cure the breach before enforcement of collateral or acceleration of the debt.\nThe Parties acknowledge that the collection, processing, storage, and sharing of personal data related to the Producer and associated individuals shall comply with the Brazilian General Data Protection Law (Lei nº 13.709/2018 – LGPD). Personal data shall be used exclusively for purposes connected to project verification, monitoring, payment processing, risk assessment, and regulatory compliance. The Producer grants consent for such processing and may request access, correction, or deletion of personal data as permitted by law. The Investor shall adopt appropriate administrative, technical, and security measures to safeguard personal data against unauthorized access, loss, or misuse.\nThis document is governed by the laws of the Federative Republic of Brazil. Any disputes shall be submitted to the courts of the judicial district where the Project Area is located. The Portuguese version of these Terms prevails over any translation; this English version is provided for convenience only.\n",
      termsText3: "",
      termsText4: ""
    },
    searchOrDrag: "Search or drag and drop",
    steps: {
      information: "Information",
      overview: "Overview",
      planting: "Planting",
      costs: "Costs",
      production: "Production",
      analysis: "Analysis",
      impact: "Impact"
    },
    nested: {
      systemWide: "System wide {year}",
      systemWideGroup: "System wide",
      speciesYear: "{species} {year}",
      systemWideProd: "System wide",
      species: "{species}"
    }
  },
  accountDetails: {
    back: "Back",
    save: "Save",
    wallet: "Wallet",
    legalAddress: "Legal address",
    registrationDate: "Registration date",
    kyc: "KYC",
    email: "Email",
    verifyEmail: "Verify email",
    emailVerificationRequested: "Email verification requested",
    kycVerified: "Verified",
    kycBlocked: "Blocked",
    kycNotVerified: "Not verified",
    verifyKycNow: "Verify now",
    kycVerificationSucceeded: "KYC verification completed",
    kycVerificationFailed: "KYC verification failed. Please try again.",
    close: "Close"
  },
  userSidePanel: {
    co2Farmed: "CO₂ farmed",
    bctLocked: "BCT locked",
    close: "Close",
    co2CapturedToday: "of CO₂ captured today",
    buy: "Buy",
    farm: "Farm",
    play: "Play",
    assets: "Assets",
    investments: "Investments",
    farming: "Farming",
    unrealizedProfit: "Unrealized profit",
    averagePaid: "Avg. paid",
    investmentUnits: "investment units"
  },
  walletPage: {
    account: "Account",
    export: "Export",
    carbonCreditsTitle: "Carbon credits",
    co2: "CO/2",
    cacaoTitle: "Cacao",
    acaiTitle: "Acai",
    inProjects: "in {count} projects",
    co2Farmed: "CO₂ farmed",
    projectsOwned: "projects owned",
    assets: "Assets",
    investments: "Investments",
    bctStaked: "BCT locked",
    totalBct: "Total BCT",
    transactions: "Transactions",
    unavailableTitle: "Something went wrong",
    unavailableDescription: "We could not load your dashboard right now. Please try again later.",
    tryAgain: "Try again",
    transactionActions: {
      BUY: "Buy",
      SELL: "Sell",
      INVEST: "Invest",
      CLAIM: "Claim"
    },
  },
  stakeComponent: {
    stake: "Stake",
    unstake: "Unstake",
    alreadyStaked: "Already locked",
    noStakes: "No stakes",
    timeToUnstake: "Time to unlock",
    readyToUnstake: "Ready to unlock",
    login: "Log in",
    enterAmount: "Please enter an amount",
    success: "Success",
    insufficientBalance: "Insufficient balance",
    lock: "Lock",
    unlock: "Unlock",
    durationDays: "Duration (days)"
  },
  impactTab: {
    jobs_number: "Jobs created",
    water_availability: "Water availability on the soil",
    soil_fertility: "Soil life/fertility",
    crop_diversity: "Crop diversity",
    fauna_increase: "Fauna in the area",
    land_conversion: "Conversion of pasture land or agriculture land to forest land",
    regenerative_food: "Production of high-quality regenerative food",
    riverbank_regeneration: "Regeneration of forest along side river banks",
    carbon_sequestration: "Carbon sequestration above / below ground",
    impactTabUnits: {
      none: "",
      hectares: "ha",
      tons: "T",
      co2Tons: "CO2 T"
    }
  },
  common: {
    maxFileSize: "Maximum allowed file size is {max}MB",
    dropFileHereOr: "Drop your file here or",
    browse: "Browse",
    addMoreFiles: "Add more files",
    replaceFile: "Replace file",
    clearFiles: "Clear files",
    clearSelection: "Clear selection",
    copied: "Copied",
    tokens: "tokens",
    claimUSDC: "Claim USDC",
    enterLocation: "Enter location",
    or: "or",
    profileChanged: "Profile changes saved",
    selectAnOption: "Select an option",
    today: "Today",
    yesterday: "Yesterday",
    projectSavedToDatabase: "Project successfully saved to database",
    projectSaved: "Project successfully saved",
    projectCreated: "Project successfully created",
    approved: "Approved",
    cancel: "Cancel",
    update: "Update",
    delete: "Delete",
    back: "Back",
    home: "Home",
    close: "Close",
    download: "Download"
  },
  farmerFormValidation: {
    fillBeforeProceeding: "Please fill {field} before proceeding.",
    projectTitle: "Project Title",
    projectDescription: "Project Description",
    projectType: "Project Type",
    jobsCreated: "Jobs Created",
    biome: "Biome",
    state: "State",
    city: "City",
    investmentCost: "Investment Cost",
    projectOwner: "Project owner",
    projectYears: "Project Duration (Years)",
    supportingDocs: "Supporting Documents",
    species: "Cash Crops (Species)",
    duplicateSpecies:
      "Duplicate species: the same crop cannot be entered in two different languages. Please remove the duplicate.",
    areaSize: "Planting Area Size",
    photos: "Project Photos",
    productionDelay: "Production Delay (Months)",
    totalSupply: "Total Supply (kg)",
    finalPrice: "Selling Price (per kg)",
    current: "Current",
    year: "Year {n}",
    systemYear: "System wide Y{year}",
    costLabels: {
      planning: "Planning & Design",
      site_preparation: "Site Preparation",
      planting: "Planting & Establishment",
      maintenance: "Maintenance and Care",
      harvest: "Harvest & Post-Harvest",
      value_addition: "Value Addition",
      marketing: "Marketing and Distribution"
    },
    costInputs: {
      labor: "Labor",
      inputs: "Inputs",
      tools: "Tools & Equipment",
      services: "Services/Consultancy",
      infrastructure: "Infrastructure"
    },
    maxYearsExceeded: "Maximum project duration is {max} years. Please enter a value between 1 and {max}."
  },
  circleLogin: {
    sendResetLink: "Send Reset Link",
    forgotPassword: "Forgot Password?",
    sendPasswordResetEmail: "Send Password Reset Email",
    enterEmail: "Please enter your email address.",
    enterEmailAndPassword: "Please enter both your email and password.",
    forgotPasswordMessageSent: "If an account with that email exists, you’ll receive a reset link shortly.",
    resetYourPassword: "Reset Your Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    saveNewPassword: "Save New Password",
    passwordResetComplete: "Your password has been reset successfully! You can now log in.",
    resetFailed: "Password reset failed. The link may be invalid or expired."
  },
  newTokenPage: {
    lockWithAmount: "Lock {amount} BCT",
    unlockWithAmount: "Unlock {amount} BCT",
    totalBctLocked: "Total BCT locked",
    nextSnapshotShare: "10k BCT next snapshot share",
    rewardPreviewUnavailable: "Unavailable",
    numberProjects: "Number of projects",
    currentProjectSize: "Current project size",
    thirdSectionDescription: "Use BCT to capture CO₂ in real time — streaming carbon credits and agroforestry rewards from cocoa, açaí, and more.",
    growTitle: "Grow your forest",
    growDescription: "We built a strategic greed-based idle game where token holders cultivate, manage and grow their rainforest ecosystems to earn rewards.",
    growEnter: "Coming soon",
    growAltMain: "Grow section illustration",
    growAltPlant: "plant",
    growAltTimer: "timer",
    growAltChart: "chart",
    growItemSpecies: "Realistic species\nmodeling",
    growItemTimer: "Real-time autonomous\ngrowth",
    growItemChart: "Increased carbon credit\nearnings by maintaining\necosystem health",
    gridItem1Title: "Lock BCT tokens",
    gridItem1Description: "Lock & Lock BCT (Supply Pressure)\nUsers lock BCT tokens, reducing\ncirculating supply and boosting token price.",
    gridItem1RightTitle: "Buy BCT tokens",
    gridItem2Title: "Your Lock generates\nyield from verified Real-World Projects",
    gridItem2Description: "Investment in verified Real-World Projects. Funds from BCT sales directly finance carbon and agroforestry projects.",
    gridItem2RightTitle: "See projects",
    gridItem3Title: "Claim generated yield as your local currency.",
    gridItem3Description: "Claim different yields — carbon credits, wood, fruits, coffee, cocoa — as USD, EUR, BRL, etc.",
    gridItem3RightTitle: "Learn more",
    faqTitle: "FAQ",
    faqItems: [
      {
        title: "Title 1",
        content: "description 1"
      },
      {
        title: "Title 2",
        content: "description 2"
      },
      {
        title: "Title 3",
        content: "description 3"
      }
    ],
    filterLock: "Lock",
    filterYield: "Yield",
    filterClaim: "Claim"
  },
  farmerCard: {
    invested: "Invested",
    deposited: "Deposited",
    stage: "Stage",
    withdraw: "Withdraw",
    withdrawUSDC: "Withdraw USDC",
    updateProduction: "Update production",
    signStage: "Sign stage",
    finalizeSpecies: "Finalize deposit",
    finalizeSummary: "You are finalizing deposit for",
    harvested: "Harvested",
    harvestedAmount: "Harvested amount (Kg)",
    pricePerKg: "Selling price / Kg",
    noUsersToAllocate: "There are no users to allocate funds to",
    stageUnknown: "—"
  },
  calculateReturns: {
    title: "Preview your V2 staking weight",
    description: "Based on the current on-chain weights at the next reward funding snapshot",
    yourDeposit: "BCT to stake",
    days: "{count} days",
    nextSnapshotShare: "Estimated next snapshot share",
    ageHalfLife: "Game age half-life",
    lockNow: "Stake BCT",
    rewardAsset: "ERC-1155 project receipt rewards",
    rewardModelTitle: "Snapshot-funded rewards",
    rewardModelExplanation: "Each receipt funding round freezes the eligible stakers and their effective weights. Your stake can participate only in rounds funded after it is active.",
    noApy: "V2 does not promise an APY. Future receipt funding, project-token prices, and other stakers' weights are unknown; existing rounds keep their original snapshot.",
    totalStaked: "Current total staked",
    activeStakers: "Active stakers",
    fundedRounds: "Funded rounds",
    configuredHalfLife: "Configured reward half-life",
    snapshotStatus: "Snapshot writes",
    snapshotReady: "Ready",
    snapshotInProgress: "Locked while snapshotting",
    loading: "Reading current V2 reward state…",
    invalidAmount: "Enter a valid BCT amount.",
    unavailable: "V2 reward state is unavailable."
  },
  developerRegistration: {
    introTitle: "Register as a developer",
    introSubtitle: "Help us an ancestral agroforest or launching a new food forest system, this form helps us understand your story, structure your data, and prepare it for impact investment.",
    getStarted: "Get started",
    noWallet: "No wallet?",
    learnWallet: "Learn how to get a wallet",
    formTitle: "Register as a developer",
    fullName: "Full name",
    email: "Email",
    phoneNumber: "Phone number",
    walletAddress: "Wallet address",
    connectWallet: "Connect wallet",
    iRepresentCompany: "I represent a company",
    company: "Company",
    companyRegistryNumber: "Company Registry Number",
    dateOfIncorporation: "Date of incorporation",
    websiteUrl: "Website URL",
    uploadCompanyLogo: "Upload company logo",
    dropFilesHere: "Drop your files here or",
    browse: "Browse",
    continueToKyc: "Continue to KYC",
    submitKycLater: "Submit and KYC later",
    verifyTitle: "Verify your email",
    verifySubtitle: "We've sent a verification code to your email address. Enter the code below to continue.",
    submitCode: "Submit code",
    requestNewCode: "Request a new code",
    verificationComplete: "Verification Complete",
    verificationMessage: "Your information has been successfully verified. You can already create a project while we validate your account.",
    createProject: "Create a project"
  },
  partnerPage: {
    hectares: "Hectares",
    projectType: "Project Type",
    step1Title: "Project Details",
    step2Title: "Project Files",
    resultTitle: "Results",
    addProjectFiles: "Add Project Files",
    uploadProjectPhotos: "Upload Project Photos (Max 16 JPG, JPEG or PNG)",
    uploadForestPhoto: "Upload Forest Cover Photo (Max 1 JPG, JPEG or PNG)",
    uploadProjectFiles: "Upload Project Files (Max 4 PDF)",
    photosUploading: "Uploading Photos...",
    filesUploading: "Uploading Files...",
    upload: "Upload",
    progress: "Progress",
    results: "Results",
    projectData: "Project Data",
    noPhotos: "No",
    images: "images",
    projectPhotos: "Project Photos",
    projectFiles: "Project Files",
    noFiles: "No",
    pdfs: "PDF's",
    noFileUploaded: "No file uploaded",
    back: "Back",
    continue: "Continue",
    backToProjectsList: "Back to Projects List",
    finished: "Finished!",
    nameForText: "Project Name",
    auditor: "Project Auditor",
    state: "Select Brazil State",
    carbonCreditSupply: "Carbon Credit Supply",
    listingPrice: "Listing Price",
    overview: "Overview",
    biodiversity: "Biodiversity",
    floraCount: "Flora species count",
    faunaCount: "Fauna species count",
    endangeredSpeciesCount: "Endangered species count",
    userNotAuthenticated: "User is not authenticated",
    summary: "Project Summary",
    commission: "Partner USD Commission",
    creditCommission: "Partner Carbon Credit Commission",
    calcReddCost: "Calculate REDD+ cost",
    auditorVerification: "Auditor for Verification",
    auditorValidation: "Auditor for Validation",
    projectPartner: "Project Partner",
    projectCertifier: "Project Certifier",
    selectBrazilState: "Select Brazil State",
    inflationRate: "Inflation Rate",
    projectCoBenefitors: "Project Co-Benefitors",
    landOwner: "Land Owner",
    forestCover: "Forest Cover",
    yearsPeriod: "Project Duration in Years",
    investorsPercent: "Investors (%)",
    ownersPercent: "Owners (%)",
    partnersPercent: "Developer (%)",
    platformPercent: "Platform (%)",
    stakersPercent: "Stakers (%)",
    historicalDeforestationRate: "Historical Deforestation Rate (0-1 scale)",
    carbonSequestrationRate: "Carbon Sequestration Rate (tons/year)",
    deforestationDrivers: "Deforestation Drivers",
    deforestationAgents: "Deforestation Agents",
    ecosystemServicesValuation: "Ecosystem Services Valuation",
    biomeAreaHectares: "Biome Area (hectares)",
    auditorFee: "Auditor Fee (%)",
    auditCost: "Audit Cost",
    tokenName: "Token Name",
    tokenSymbol: "Token Symbol",
    registerAsDeveloper: "Register as developer",
    numberCarbonCredits: "Number of Carbon Credits"
  }
};
